module.exports = "<settings-page></settings-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/settings.html
// module id = 1414
// module chunks = 0